import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { Panel } from "@/components/dash/Ui";
import { ClicksTable } from "@/components/dash/ClicksTable";

export const RecentClicks = ({ range, linkId, limit = 10, title = "Recent clicks" }) => {
  const [rows, setRows] = useState([]);
  useEffect(() => {
    api.get("/clicks", { params: { start: range.start, end: range.end, link_id: linkId, limit } }).then((r) => setRows(r.data));
  }, [range, linkId, limit]);
  return (
    <Panel className="mt-4">
      <div className="flex justify-between items-center mb-4">
        <h2 className="font-display text-lg font-semibold">{title}</h2>
        {!linkId && <Link to="/dashboard/clicks" data-testid="view-all-clicks-link" className="text-sm text-emerald-400 hover:text-emerald-300">View all</Link>}
      </div>
      <ClicksTable rows={rows} />
    </Panel>
  );
};
